import React, {Component} from 'react';
import styled from 'styled-components';
import {ThemeText} from '../styled-components/styles';
import CartIcon from './CartIcon';
import {connect} from 'react-redux'

class Cart extends Component {

  changeOpenState(e) {
    e.stopPropagation();
    this.props.changeOpenState();
  }

  render() {
    let itemDom, PriceDom;
    // start to calc cart DOM once item added to Cart
    if(this.props.cart) {
      itemDom = this.props.cart.map((i, index)=> {
        return (
          <>
          {index === 0 ? (
            <div key="Cart title" className="cart-title flex align-center width-100 justify-space-between">
              <p>Name</p>
              <p>Price</p>
              <p>Num</p>
            </div>)  : null}
          <div key={i.id} className="each-item flex align-center width-100 justify-space-between">
            <div className="t-left">
              <p>{i.info.name}</p>
              <p className="small-title">{i.info.en}</p>
            </div>
            {/* @TOBE MODIFIED - Division of different data structure of price*/}
            {typeof i.info.price === 'number' ? <p>{i.info.price}</p> : <p>{i.info.price.large}</p>}
            <p>{i.num}</p>
          </div>
          </>
        )
      })
    }

    // Calc final price DOM
    if(this.props.cart) {
      let price = this.props.cart.reduce((accumulator, currentItem)=> {
        return currentItem.info.price * currentItem.num + accumulator
      }, 0);

      PriceDom = <div className="flex justify-end">
        <p>Order Price: </p>
        <ThemeText className="t-bold"> ${price}</ThemeText>
      </div>
    }
    
    return (
      <>
        <CartContent className={`fixed ${this.props.cartOpen ? 'active' : null}`} onClick={(e)=>e.stopPropagation()}>
          <Close className="absolute iconfont" onClick={()=>this.props.changeOpenState('close')}>&#xe61f;</Close>
          {itemDom}
          {PriceDom}
        </CartContent>
        {this.props.cart ? <div className="fixed" style={{'bottom': '30px', "right": "30px"}} onClick={(e)=>this.changeOpenState(e)}>
          <CartIcon cart={this.props.cart}></CartIcon>
        </div> : null}
      </>
    )
  }
}



const CartContent = styled.div`
  background: #fff;
  display: none;
  right: 30px;
  bottom: 100px;
  border-radius: 4px;
  box-shadow: 2px 2px 5px 0 rgba(100, 100, 100, 0.5), -2px -2px 7px 0 rgba(150, 150, 150, 0.2);
  overflow-y: scroll;

  &.active {
    display: block;
    animation: show .6s ease-in-out;
  }
  width: 300px;
  height: 500px;
  padding: 35px 15px 10px;

  p {
    margin: .3em 0;
  }

  .each-item {
    border-bottom: 1px solid #ddd;
  }
  .small-title {
    font-size: .8em;
  }

  .cart-title {
    color: #bbb;
    font-weight: bold;
  }
  
  @media screen and (max-width: 500px){
    width: 100%;
    height: 100%;
    right: 0;
    bottom: 0;
  }
`

const Close = styled.i`
  right: 15px;
  top: 15px;
  cursor: pointer;
`


const mapStateToProp = (state) => {
  return { cart: state.cart };
}

export default connect(mapStateToProp)(Cart);